import { useThemeContext } from "@circle-react/providers/Theme";
import type { MemberTag as MemberTagProps } from "@circle-react/types";

import { t } from "@/i18n-js/instance";
import { Badge } from "@/react/components/SettingsApp/CompassCompat/Badge";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

import { MemberTag } from "./MemberTag";

interface ShowMoreTagProps {
  labelVariant?: "words" | "numbers";
  memberTags: MemberTagProps[];
}
export const ShowMoreTag = ({
  memberTags,
  labelVariant = "words",
}: ShowMoreTagProps) => {
  const { currentAppearance } = useThemeContext();

  const tooltipContent = (
    <ul className="flex !list-none flex-col gap-1 py-1">
      {memberTags.map((memberTag: MemberTagProps) => (
        <li key={memberTag.id}>
          <MemberTag
            memberTag={{
              ...memberTag,
            }}
            className="border-secondary"
          />
        </li>
      ))}
    </ul>
  );

  const label =
    labelVariant === "words"
      ? t("member_tags.show_more", {
          count: memberTags.length,
        })
      : `+${memberTags.length}`;

  return (
    <div>
      <TippyV2
        content={tooltipContent}
        className="flex"
        theme={currentAppearance}
      >
        <Badge label={label} variant="secondary" />
      </TippyV2>
    </div>
  );
};
